
export default {
  props: {
    idx: {
      type: Number,
      default: () => {
        return 0
      }
    },
    latitude: {
      type: Number,
      default: () => {
        return 0
      }
    },
    longitute: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data () {
    return {
      map: null,
      marker: null,
      innerValue: '',
      divValue: 'map'
    }
  },
  head () {
    return {
      script: [
        { src: 'https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=1ih8eevqgm' }
      ]
    }
  },
  beforeDestroy () {
    this.destroyMap()
  },
  methods: {
    create () {
      this.innerValue = this.divValue + this.idx
      this.$nextTick(() => {
        this.waitForNaver(0)
      })
    },
    waitForNaver (retry) {
      if (retry > 50) { return }
      if (window.naver && window.naver.maps) {
        this.initMap()
      } else {
        setTimeout(() => { this.waitForNaver(retry + 1) }, 200)
      }
    },
    initMap () {
      const container = document.getElementById(this.innerValue)
      if (!container) { return }

      // 이전 지도 정리
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
      container.innerHTML = ''

      const center = new naver.maps.LatLng(this.longitute, this.latitude)

      this.map = new naver.maps.Map(container, {
        center,
        zoom: 16,
        zoomControl: true,
        zoomControlOptions: {
          position: naver.maps.Position.TOP_RIGHT
        }
      })

      // eslint-disable-next-line no-new
      this.marker = new naver.maps.Marker({
        position: center,
        map: this.map
      })

      this.$emit('mountCallback')
    },
    relayout () {
      if (this.map) {
        const container = document.getElementById(this.innerValue)
        if (container) {
          const w = container.offsetWidth
          const h = container.offsetHeight
          if (w > 0 && h > 0) {
            this.map.setSize(new naver.maps.Size(w, h))
          }
        }
      }
    },
    destroyMap () {
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
      this.marker = null
      const container = document.getElementById(this.innerValue)
      if (container) {
        container.innerHTML = ''
      }
    }
  }
}
